import { MutationCache, QueryClient } from "@tanstack/react-query";

import { toast } from "@punto-firma/ui/components/toaster";

import { isApiError } from "./client";

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: {
      /** No mostrar el toast de error genérico (la pantalla lo pinta ella). */
      silentError?: boolean;
    };
  }
}

/**
 * Errores uniformes: toda mutación que falla muestra un toast con el `message`
 * del `{error}` de la API, salvo que declare `meta: { silentError: true }`.
 * Las consultas no: cada pantalla pinta su estado de error (`ErrorState`).
 * Los 401 no llegan aquí como toast: los gestiona `setUnauthorizedHandler`.
 */
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Un 4xx no se arregla reintentando.
          if (isApiError(error) && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
      },
    },
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.meta?.silentError) return;
        if (isApiError(error) && error.status === 401) return;
        toast.error(error.message);
      },
    }),
  });
